import { render, staticRenderFns } from "./blog.vue?vue&type=template&id=4db8f936&"
import script from "./blog.vue?vue&type=script&lang=js&"
export * from "./blog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/arthur.cruz/BRNDWGN/Projects/mz-marketing-wp/web/app/themes/mz-marketing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4db8f936')) {
      api.createRecord('4db8f936', component.options)
    } else {
      api.reload('4db8f936', component.options)
    }
    module.hot.accept("./blog.vue?vue&type=template&id=4db8f936&", function () {
      api.rerender('4db8f936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/blog.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/blog.vue
// module id = 77
// module chunks = 0